
export function downloadFile(url, onErrorCallback) {
  /**
   * Bajar un archivo en forma "controlada" al hacer click en el link correspondinte.
   * 
   * Hasta ahora (enero-2021) el uso de iframe (sin cookie) es única solución viable,
   * porque la opción de agregar una cookie tiene problemas cuando se usa un GET 
   * cross-site para bajar el archivo, ya que la generacion de la Cookie en este 
   * contexto es "problematica": se debe usar "SameSite=None; Secure" pero esto 
   * tambien requiere usar Https, que complica su uso durante el desarrollo.
   * 
   * Si no es así la cookie generada es simplemente ignorada por no ser segura.
   * 
   * Ver: [SameSite cookies explained](https://web.dev/samesite-cookies-explained/)
   * 
   * Articulos relacionados (anteriores):
   * 
   * http://johnculviner.com/jquery-file-download-plugin-for-ajax-like-feature-rich-file-downloads/
   * https://stackoverflow.com/questions/17022247/downloading-large-files-with-jquery-iframe-need-a-file-ready-event-so-i-can
   * https://stackoverflow.com/questions/3749231/download-file-using-javascript-jquery
   * https://stackoverflow.com/questions/1106377/detect-when-browser-receives-file-download
   * 
   * @requires: `jQuery`
   * 
   * @created: 20-01-2021
   * @author: Mario A. Zito <mario.zito@treme.io>
  */
  // alert("Download file")

  /* Se usa un iframe para evitar que se salga de la pagina si
    falla el download. Lamentablemente no podemos saber cuando el download
    a finalizado */
  jQuery("#tmp_iframe").remove(); // por si existia antes
  var iframe = document.createElement('iframe');
  iframe.id = "tmp_iframe";
  iframe.style = "display:none;";
  jQuery(document).find("body").append(iframe) ;
  
  function _failed(done) {
      /* Cuando el iframe recibe una respuesta del servidor
        y se llena la pagina con el mensaje de error, entonces 
        el iframe recien avisa que fue 'cargado'. 
        Por eso la aparicion del error dispara el 'onload', 
        al reves de lo que uno esperaria :-(( */
      if (onErrorCallback) 
        onErrorCallback()
      else
        alert("No pudimos bajar el archivo. Intenta más tarde ...");

      jQuery("#tmp_iframe").remove() ;
  }
  
  // starts the download
  iframe.onload = _failed ;
  iframe.src = url;
}


export function createTextFileAndDownload(filename, text) {
  var element = document.createElement('a');
  //element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + text);
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}
